import { render, staticRenderFns } from "./TransferSample.vue?vue&type=template&id=4159e4de&scoped=true"
import script from "./TransferSample.vue?vue&type=script&lang=js"
export * from "./TransferSample.vue?vue&type=script&lang=js"
import style0 from "./TransferSample.vue?vue&type=style&index=0&id=4159e4de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4159e4de",
  null
  
)

export default component.exports